<template>
  <div>
    <v-btn
      id="saveBtn"
      fixed
      right
      bottom
      outline
      depressed
      :loading="loader"
      :disabled="loader"
      class="text-xs-center sz_violet--text text-capitalize"
      :class="{ green: correct }"
      color="white"
      @click="save"
    >
      <div v-if="!correct">
        {{ $t('message.save_temp') }}
      </div>
      <v-icon
        v-else
        class="green--text fw-600"
      >
        check
      </v-icon>
    </v-btn>
  </div>
</template>

<script>
export default {
    name: 'SaveDraftButton',
    props: {
        type: {
            default: null
        }
    },
    data () {
        return {
            loader: false,
            correct: false
        };
    },
    computed: {
        familyId () {
            return this.$route.params.familyId;
        }
    },
    mounted () {
        this.buttonPosition();
        window.addEventListener('scroll', this.buttonPosition);
    },
    beforeDestroy () {
        window.removeEventListener('scroll', this.buttonPosition);
    },
    methods: {
        save () {
            if (this.correct === true) {
                return;
            }
            if (this.familyId && this.type) {
                this.loader = true;
                this.$store
                    .dispatch('specialistPackage/saveDraft', {
                        familyId: this.$route.params.familyId,
                        type: this.type
                    })
                    .then(() => {
                        this.correct = true;
                        setTimeout(() => {
                            this.correct = false;
                        }, 1500);
                    })
                    .finally(() => {
                        this.loader = false;
                        this.$emit('finish', false);
                    });
            }
        },
        buttonPosition () {
            if (!document.body) return;
            const offset = document.body.offsetHeight - (window.innerHeight + window.scrollY);
            const button = document.getElementById('saveBtn');
            if (button) {
                if (window.innerHeight + window.scrollY >= document.body.offsetHeight - 70) {
                    button.style.marginBottom = 70 - offset + 'px';
                } else {
                    button.style.marginBottom = 0 + 'px';
                }
            }
        }
    }
};
</script>

<style scoped>
#saveBtn {
  font-size: 16px;
}
</style>
